const OAUTH_ERROR_MESSAGES = {
  access_denied: 'アクセスが拒否されました。もう一度お試しください。',
  invalid_state: 'セッションが無効です。もう一度お試しください。',
  invalid_request: '無効なリクエストです。',
  server_error: 'サーバーエラーが発生しました。',
  temporarily_unavailable: '一時的に利用できません。',
  default: 'エラーが発生しました。もう一度お試しください。',
} as const;

type ErrorCode = keyof typeof OAUTH_ERROR_MESSAGES;

export const getOAuthErrorMessage = (errorCode: string | null | undefined): string => {
  if (!errorCode) {
    return OAUTH_ERROR_MESSAGES.default;
  }

  if (errorCode in OAUTH_ERROR_MESSAGES) {
    return OAUTH_ERROR_MESSAGES[errorCode as ErrorCode];
  }

  return OAUTH_ERROR_MESSAGES.default;
};
